type LevelGroupLabelOptions = {
  multiSelect?: boolean
  noun?: string
}

export function levelGroupLabelFor(skillName: unknown, { multiSelect = false, noun = 'Level' }: LevelGroupLabelOptions = {}): string {
  const label = multiSelect ? `${noun}s` : noun
  const name = typeof skillName === 'string' ? skillName.trim() : ''
  return name ? `${label} for ${name}` : label
}
